<script setup>
import { computed } from 'vue'
import Avatar from 'primevue/avatar'
import Tag from 'primevue/tag'
import { FORM_COLOR_MAP, getColleagueColor } from '../../../composables/useReservationsCalendar.js'

const props = defineProps({
    item:         { type: Object, required: true },
    workerIndex:  { type: Number, default: 0 },
})

const formHex = computed(() => FORM_COLOR_MAP[props.item.formColor] ?? '#6B7280')
const workerColor = computed(() => getColleagueColor(props.workerIndex))
</script>

<template>
    <div class="flex items-center gap-3 py-2.5 border-b border-gray-100 dark:border-neutral-800 last:border-b-0">
        <div class="w-[84px] flex-shrink-0">
            <div class="text-[12.5px] font-bold text-gray-900 dark:text-white">{{ item.timeStart }}</div>
            <div class="text-[10.5px] text-gray-400 dark:text-neutral-500 font-medium uppercase tracking-wide mt-0.5">{{ item.when }}</div>
        </div>

        <div class="w-2 h-2 rounded-[3px] flex-shrink-0" :style="{ background: formHex }"/>

        <div class="flex-1 min-w-0">
            <div class="text-[13px] font-semibold text-gray-900 dark:text-white truncate">{{ item.name }}</div>
            <div class="text-[11.5px] text-gray-400 dark:text-neutral-500">{{ item.formName }}</div>
        </div>

        <Avatar
            v-if="item.worker"
            :label="item.worker.initials"
            shape="circle"
            :style="{ width: '24px', height: '24px', minWidth: '24px', background: workerColor, color: 'white', fontSize: '9px', fontWeight: 'bold' }"
        />

        <Tag
            :value="item.status === 'pending' ? $t('dashboard.status_pending') : $t('dashboard.status_confirmed')"
            :severity="item.status === 'pending' ? 'warn' : 'success'"
            class="!text-[9px] !px-1.5 !py-0.5 flex-shrink-0"
        />
    </div>
</template>
